import axios from 'axios'

let CANCEL_TOKEN_SOURCE = axios.CancelToken.source()
const TIMEOUT = 60 * 15 * 1000
const cancelAxiosRequest: any = () => {
  CANCEL_TOKEN_SOURCE.cancel()
  CANCEL_TOKEN_SOURCE = axios.CancelToken.source()
}
class Http {
  token: string | undefined
  constructor() {
    this.token = (import.meta.env.VITE_APP_TOKEN_JWT as string).replace(/Bearer /g, '')
  }

  generateHeaders(contentType: string, lang?: string) {
    const headers = {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': contentType,
      'Accept': contentType,
      'Accept-Language': lang,
      'Authorization': `Bearer ${this.token}`,
    }
    return headers
  }

  /**
   * how to use
   * http.get()
   */
  async call(parameter: any) {
    const esc = encodeURIComponent
    let headers = this.generateHeaders('application/json', parameter?.lang || 'en')
    if (parameter && parameter.headers) {
      headers = {
        ...headers,
        ...parameter.headers,
      }
      delete parameter.headers
    }
    const { method, url, params, data } = parameter
    let uri = url
    if (params) {
      const query = Object.keys(params)
        .map(k => `${esc(k)}=${esc(params[k])}`)
        .join('&')

      let operator = '?'
      if (uri && uri.includes('?'))
        operator = '&'

      uri = `${url}${operator}${query}`
    }

    // generate headers for this request
    const timeout = setTimeout(() => {
      cancelAxiosRequest()
    }, TIMEOUT)
    return await axios({
      timeout: TIMEOUT,
      method,
      url,
      headers,
      params,
      data,
      cancelToken: CANCEL_TOKEN_SOURCE.token,
    }).then((res: any) => {
      clearTimeout(timeout)
      return res
    }).catch((err) => {
      clearTimeout(timeout)
      return err
    })
  }
}
export default new Http()
